module.exports = __webpack_public_path__ + "img/news14_3.8565fb79.jpg";